// 調整班表月檢視的事件轉換與篩選
// 這裡的函式必須是純的：直接改動 redux store 內的事件物件會在重繪時把 title 一再截短

// 把後端回傳的事件轉成 fullcalendar 月檢視要的格式
export function toCalendarEvents(rawEvents = []) {
  return rawEvents.map((event) => {
    const titleArr = event.title.split('-');
    let title = titleArr.length === 3 ? `${titleArr[0]}-${titleArr[2]}` : titleArr[0];

    const startTimePart = event.start.split('T')[1];
    if (event.start.indexOf(':') !== -1) {
      title = startTimePart.substring(0, startTimePart.lastIndexOf(':')) + title;
    }

    const calendarEvent = {
      ...event,
      title,
      start: event.start.split('T')[0],
      end: event.end.split('T')[0],
    };

    if (startTimePart) {
      calendarEvent.sort = startTimePart.substring(0, startTimePart.lastIndexOf(':'));
    }

    // resourceId 即 jobTypeId
    if (event.resourceId === 3 || event.resourceId === 4 || event.resourceId === 5) {
      // 包場、課程、活動不屬於個人，排在當日最前面
      calendarEvent.color = 'Plum';
      calendarEvent.sort = '0';
    } else if (event.resourceId === 8) {
      calendarEvent.color = 'FireBrick';
    } else if (event.resourceId === 9) {
      calendarEvent.color = 'Gold';
    } else if (event.resourceId === 10) {
      calendarEvent.color = 'IndianRed';
    }

    return calendarEvent;
  });
}

// 沒有選取任何員工時代表不篩選；沒有對應員工的事件（包場、課程、活動）一律保留
export function filterEventsByStaff(events = [], selectedStaffIds = []) {
  if (selectedStaffIds.length === 0) return events;
  return events.filter(
    (event) => event.userId === null || event.userId === undefined || selectedStaffIds.indexOf(event.userId) !== -1,
  );
}
